"use client";

import React from "react";
import { BlurFade } from "@/components/ui/blur-fade";
import { Award } from "lucide-react";

interface TrustBadge {
  name: string;
  year?: string;
}

interface TrustBadgesProps {
  title?: string;
  badges: TrustBadge[];
}

const TrustBadges = ({ title, badges }: TrustBadgesProps) => {
  if (!badges || badges.length === 0) return null;

  return (
    <section className="py-16 px-6 bg-muted/50">
      <div className="container max-w-5xl mx-auto flex flex-col items-center gap-8">
        {title && (
          <BlurFade delay={0.1}>
            <p className="text-sm font-semibold text-foreground/40 uppercase tracking-widest">
              {title}
            </p>
          </BlurFade>
        )}

        <BlurFade delay={0.2}>
          <div className="flex flex-wrap items-center justify-center gap-5">
            {badges.map((badge, i) => (
              <div
                key={i}
                className="flex flex-col items-center gap-2 px-6 py-4 bg-white rounded-2xl border border-foreground/5 hover:shadow-md transition-shadow"
              >
                <Award size={28} className="text-foreground/30" strokeWidth={1.5} />
                <span className="text-sm font-bold text-foreground/70 text-center leading-tight">
                  {badge.name}
                </span>
                {badge.year && (
                  <span className="text-xs text-foreground/40 font-medium">
                    {badge.year}
                  </span>
                )}
              </div>
            ))}
          </div>
        </BlurFade>
      </div>
    </section>
  );
};

export default TrustBadges;
